// components/ChatWidget.tsx
"use client";
import { useEffect } from "react";
import { useUserStore } from "@/store/user-store"; // your Zustand store

export default function ChatWidget() {
  const user = useUserStore((state) => state.user); // { name, email }

  useEffect(() => {
    // Load the Tawk.to script
    const s1 = document.createElement("script");
    s1.src = "https://embed.tawk.to/689a30fdc8a5591922590eb7/1j2d4uo4s";
    s1.async = true;
    s1.setAttribute("crossorigin", "*");
    document.body.appendChild(s1);

    // Wait for Tawk_API to be ready and then set custom data
    const interval = setInterval(() => {
      if (window && (window as any).Tawk_API && (window as any).Tawk_API.setAttributes) {
        (window as any).Tawk_API.setAttributes(
          {
            name: user?.firstName + " " + user?.lastName || "Guest",
            email: user?.email || "",
            phone: user?.phoneNumber || "",
            userId: user?.id || "",
            accountId: user?.accountId || "",
            isAdmin: user?.isAdmin || "",
            isOnline: user?.isOnline || "",
            isVerified: user?.isVerified || "",
          },
          function (error: any) {
            if (error) console.error("Tawk API Error:", error);
          }
        );
        clearInterval(interval);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [user]);

  return null;
}